import React, { useState } from 'react';
import Helmet from 'react-helmet';
import {Link, Route} from 'react-router-dom';
import { useQuery } from 'react-apollo';
import capitalize from 'lodash/capitalize';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListSubheader from '@material-ui/core/ListSubheader';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import FolderIcon from '@material-ui/icons/Folder';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Spin from 'components/common/Spin';
import { GET_ALL_MODULES } from 'graphql/admin/curriculum';
import ViewExercise from "./ViewExercise";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: theme.spacing(3),
  },
  list: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  addAction: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
}));

const CurriculumList = ({ match }) => {
  const classes = useStyles();
  const { data } = useQuery(GET_ALL_MODULES, { fetchPolicy: "cache-and-network" });
  const { moduleId } = match.params;

  const exercises = data?.modules
    .find((m) => m.id === Number(moduleId))
    ?.exercises
    .map(i => (
      <ListItem
        divider
        button
        key={i.id}
        component={Link}
        to={`/curriculum/${moduleId}/exercises/${i.id}`}
      >
        <ListItemAvatar>
          <Avatar>
            <ListAltIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={i.name}
          secondary={`Duration: ${i.duration} minutes`}
        />
      </ListItem>
    ))

  return (
    <div>
      <Helmet title="Curriculum" />
      { !data ? <Spin spinning linear /> : (
        <Grid container spacing={3}>
          <Grid item md={5}>
            <List className={classes.list} disablePadding>
              {data.modules.map((i) => (
                <ListItem
                  button
                  divider
                  selected={i.id === Number(moduleId)}
                  component={Link}
                  to={`/curriculum/${i.id}`}
                >
                  <ListItemAvatar>
                    <Avatar>
                      {i.id === Number(moduleId) ? <FolderOpenIcon /> : <FolderIcon />}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={i.name} secondary={i.curriculum.name} />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid item md={7}>
            {!moduleId ? (
              <Typography variant="subtitle1">Please select a module</Typography>
            ) : (
              <React.Fragment>
                <List
                  className={classes.list}
                  disablePadding
                  subheader={<ListSubheader disableSticky>Exercises</ListSubheader>}
                >
                  {exercises}
                </List>
              </React.Fragment>
            )}
          </Grid>
        </Grid>
      )}
      <Route exact path="/curriculum/:moduleId/exercises/:id" component={ViewExercise} />
    </div>
  );
};

export default CurriculumList;
